<div class="machines-filter-panel">
  <div class="environment">
    <div class="filter-label">
      {{
        "compatibility.compatibleMachines.filters.environmentFiltersLabel"
          | translate
      }}
    </div>
    <div class="filter-buttons">
      <button
        class="filter-button"
        (click)="onEnvironmentClick('all')"
        [ngClass]="{ active: environmentFilter === 'all' }"
        [title]="'compatibility.compatibleMachines.filters.all' | translate"
      >
        <span class="icon icon-all"></span>
      </button>
      <button
        class="filter-button"
        (click)="onEnvironmentClick('ios')"
        [ngClass]="{ active: environmentFilter === 'ios' }"
        [title]="'compatibility.environment.technologies.ios' | translate"
      >
        <span class="icon icon-apple"></span>
      </button>
      <button
        class="filter-button"
        (click)="onEnvironmentClick('android')"
        [ngClass]="{ active: environmentFilter === 'android' }"
        [title]="'compatibility.environment.technologies.android' | translate"
      >
        <span class="icon icon-android"></span>
      </button>
      <button
        class="filter-button"
        (click)="onEnvironmentClick('embedded')"
        [ngClass]="{ active: environmentFilter === 'embedded' }"
        [title]="'compatibility.environment.technologies.embedded' | translate"
      >
        <span class="icon icon-embedded"></span>
      </button>
    </div>
  </div>

  <div class="equipment">
    <div class="filter-label">
      {{
        "compatibility.compatibleMachines.filters.equipmentFiltersLabel"
          | translate
      }}
    </div>
    <div class="filter-buttons">
      <button
        class="filter-button"
        (click)="onEquipmentClick('all')"
        [ngClass]="{ active: equipmentFilters.includes('all') }"
        [title]="'compatibility.compatibleMachines.filters.all' | translate"
      >
        <span class="icon icon-all"></span>
      </button>
      <button
        class="filter-button"
        *ngFor="let machineType of machineTypes"
        (click)="onEquipmentClick(machineType)"
        [ngClass]="{ active: equipmentFilters.includes(machineType) }"
        [title]="machineType.name | translate"
      >
        <span class="icon" [ngClass]="machineType.icon"></span>
      </button>
    </div>
  </div>
</div>
